import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["citation"]

  copyCitation(event) {
    var citation = this.citationTarget.innerHTML;

    navigator.clipboard.writeText(citation).then(() => {
      alert('Citation copied to clipboard!');
    }).catch(err => {
      alert('Failed to copy text: ', err);
    });
  }
}
